var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 493.5C174.6 459.3 146.5 432 112 432L112 256C144.1 256 170.7 232.3 175.3 201.4C239.1 204.6 290.6 187.4 336 172.3L340.8 170.7C382.9 156.7 420.2 144.8 464.1 146.5C465.4 180.7 493.6 208 528.1 208L528.1 384C496 384 469.4 407.7 464.8 438.6C401 435.4 349.5 452.6 304.1 467.7L299.4 469.3C257.3 483.3 220 495.2 176.1 493.5zM112 192L112 191.8L112.8 192L112 192zM528 448L528 448.2C527.7 448.1 527.5 448.1 527.2 448L528 448zM64 173.5L64 483.6C64 503 75.8 520.9 94.3 526.9C188.3 556.9 253.1 535.3 317.6 513.8C380 493 442 472.3 529.7 498.5C551.9 505.1 575.9 489.7 575.9 466.5L575.9 156.4C575.9 137 564.1 119.1 545.6 113.1C451.6 83.1 386.8 104.7 322.3 126.2C259.9 147 197.9 167.7 110.2 141.5C88 134.9 63.9 150.3 63.9 173.5zM400 320C400 267 364.2 224 320 224C275.8 224 240 267 240 320C240 373 275.8 416 320 416C364.2 416 400 373 400 320z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillWave);
export default __webpack_public_path__ + "static/media/bill-wave.900369faa324a9d693a4cd39171d48b6.svg";
export { ForwardRef as ReactComponent };